/**
 * Chutt... - Circular Objective Gauge
 * Mini circular progress indicator for objectives
 */
import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { colors } from '../../styles/colors';

function CircularObjectiveGauge({ value, label, current, target, unit, size = 70 }) {
  const progress = Math.min(100, value || 0);
  const circumference = 2 * Math.PI * 25;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  const getColor = (pct) => {
    if (pct >= 100) return colors.success;
    if (pct >= 70) return colors.accent;
    if (pct >= 40) return colors.warning;
    return colors.danger;
  };

  return (
    <Tooltip title={`${Math.round(current)} / ${Math.round(target)} ${unit}`}>
      <Box sx={{ textAlign: 'center', cursor: 'pointer' }}>
        <Box sx={{ position: 'relative', width: size, height: size, mx: 'auto' }}>
          <svg width={size} height={size} viewBox="0 0 60 60" role="img" aria-label={`Progression: ${Math.round(progress)}%`}>
            <circle
              cx="30"
              cy="30"
              r="25"
              fill="none"
              stroke={colors.gray200}
              strokeWidth="5"
            />
            <circle
              cx="30"
              cy="30"
              r="25"
              fill="none"
              stroke={getColor(progress)}
              strokeWidth="5"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              transform="rotate(-90 30 30)"
              style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(0.4, 0, 0.2, 1)' }}
            />
          </svg>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 'bold',
                color: getColor(progress),
              }}
            >
              {Math.round(progress)}%
            </Typography>
          </Box>
        </Box>
        {label && (
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              mt: 0.5,
              color: colors.gray500,
              fontSize: '0.65rem',
              lineHeight: 1.2,
            }}
          >
            {label}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
}

export default CircularObjectiveGauge;
